/* tslint:disable */
/* eslint-disable */
/**
 * 
 * @export
 * @interface ApiError
 */
export interface ApiError {
    /**
     * 
     * @type {string}
     * @memberof ApiError
     */
    errorMessage?: string;
}

/**
 *
 * @export
 * @interface ClonedDatasetResponse
 */
export interface ClonedDatasetResponse {
  /**
   *
   * @type {string}
   * @memberof ClonedDatasetResponse
   */
  datasetId?: string;
  /**
   *
   * @type {boolean}
   * @memberof ClonedDatasetResponse
   */
  isActiveVersion?: boolean;
  /**
   *
   * @type {string}
   * @memberof ClonedDatasetResponse
   */
  datasetVersionLabel?: string;
  /**
   *
   * @type {number}
   * @memberof ClonedDatasetResponse
   */
  datasetVersion?: number;
  /**
   *
   * @type {DatasetType}
   * @memberof ClonedDatasetResponse
   */
  datasetType?: DatasetType;
  /**
   *
   * @type {string}
   * @memberof ClonedDatasetResponse
   */
  powerBiId?: string;
  /**
   *
   * @type {string}
   * @memberof ClonedDatasetResponse
   */
  datasetDescription?: string;
  /**
   *
   * @type {string}
   * @memberof ClonedDatasetResponse
   */
  datasetMandatoryDataPoints?: string;
  /**
   *
   * @type {number}
   * @memberof ClonedDatasetResponse
   */
  createdAt?: number;
  /**
   *
   * @type {number}
   * @memberof ClonedDatasetResponse
   */
  updatedAt?: number;
  /**
   *
   * @type {string}
   * @memberof ClonedDatasetResponse
   */
  createdBy?: string;
  /**
   *
   * @type {string}
   * @memberof ClonedDatasetResponse
   */
  updatedBy?: string;
}


/**
 * 
 * @export
 * @interface Column
 */
export interface Column {
  /**
   *
   * @type {string}
   * @memberof Column
   */
  columnId?: string
  /**
   *
   * @type {number}
   * @memberof Column
   */
  columnVersion?: number
  /**
   *
   * @type {string}
   * @memberof Column
   */
  columnName?: string
  /**
   *
   * @type {string}
   * @memberof Column
   */
  columnDescription?: string
  /**
   *
   * @type {Array<DatasetRule>}
   * @memberof Column
   */
  rules?: Array<DatasetRule>
  /**
   *
   * @type {Array<string>}
   * @memberof Column
   */
  columnSynonyms?: Array<string>
  /**
   *
   * @type {MetricTypes}
   * @memberof Column
   */
  columnType?: MetricTypes
  /**
   *
   * @type {number}
   * @memberof Column
   */
  createdAt?: number
  /**
   *
   * @type {number}
   * @memberof Column
   */
  updatedAt?: number
  /**
   *
   * @type {string}
   * @memberof Column
   */
  createdBy?: string
  /**
   *
   * @type {string}
   * @memberof Column
   */
  updatedBy?: string
  /**
   *
   * @type {boolean}
   * @memberof Column
   */
  isActive?: boolean
}


/**
 *
 * @export
 * @interface CreateColumnRequest
 */
export interface CreateColumnRequest {
  /**
   *
   * @type {string}
   * @memberof CreateColumnRequest
   */
  columnName: string
  /**
   *
   * @type {string}
   * @memberof CreateColumnRequest
   */
  columnDescription: string
  /**
   *
   * @type {MetricTypes}
   * @memberof CreateColumnRequest
   */
  columnType: MetricTypes
  /**
   *
   * @type {Array<DatasetRule>}
   * @memberof CreateColumnRequest
   */
  rules?: Array<DatasetRule>
  /**
   *
   * @type {Array<string>}
   * @memberof CreateColumnRequest
   */
  columnSynonyms?: Array<string>
  /**
   *
   * @type {boolean}
   * @memberof CreateColumnRequest
   */
  isActive?: boolean
}


/**
 *
 * @export
 * @interface CreateColumnResponse
 */
export interface CreateColumnResponse {
    /**
     * 
     * @type {string}
     * @memberof CreateColumnResponse
     */
    columnId?: string;
}

/**
 *
 * @export
 * @interface CreateDatasetRequest
 */
export interface CreateDatasetRequest {
  /**
   *
   * @type {string}
   * @memberof CreateDatasetRequest
   */
  cloneFromId?: string;
  /**
   *
   * @type {string}
   * @memberof CreateDatasetRequest
   */
  datasetName?: string;
  /**
   *
   * @type {string}
   * @memberof CreateDatasetRequest
   */
  datasetVersionLabel?: string;
  /**
   *
   * @type {string}
   * @memberof CreateDatasetRequest
   */
  datasetDescription?: string;
  /**
   *
   * @type {string}
   * @memberof CreateDatasetRequest
   */
  datasetMandatoryDataPoints?: string;
  /**
   *
   * @type {string}
   * @memberof CreateDatasetRequest
   */
  datasetPowerBiId?: string;
  /**
   *
   * @type {DatasetType}
   * @memberof CreateDatasetRequest
   */
  datasetType?: DatasetType;
}


/**
 * 
 * @export
 * @interface CreateMetricRequest
 */
export interface CreateMetricRequest {
  /**
   *
   * @type {string}
   * @memberof CreateMetricRequest
   */
  metricName: string
  /**
   *
   * @type {string}
   * @memberof CreateMetricRequest
   */
  metricDescription: string
  /**
   *
   * @type {MetricTypes}
   * @memberof CreateMetricRequest
   */
  metricType: MetricTypes
  /**
   *
   * @type {string}
   * @memberof CreateMetricRequest
   */
  metricFormula?: string
  /**
   *
   * @type {Array<DatasetRule>}
   * @memberof CreateMetricRequest
   */
  rules?: Array<DatasetRule>
  /**
   *
   * @type {Array<string>}
   * @memberof CreateMetricRequest
   */
  metricSynonyms?: Array<string>
  /**
   *
   * @type {boolean}
   * @memberof CreateMetricRequest
   */
  isActive?: boolean
}


/**
 *
 * @export
 * @interface CreateMetricResponse
 */
export interface CreateMetricResponse {
    /**
     * 
     * @type {string}
     * @memberof CreateMetricResponse
     */
    metricId?: string;
}
/**
 * 
 * @export
 * @interface CreateTableRequest
 */
export interface CreateTableRequest {
  /**
   *
   * @type {string}
   * @memberof CreateTableRequest
   */
  tableName: string
  /**
   *
   * @type {string}
   * @memberof CreateTableRequest
   */
  tableDescription: string
  /**
   *
   * @type {Array<string>}
   * @memberof CreateTableRequest
   */
  tableSynonyms?: Array<string>
  /**
   *
   * @type {boolean}
   * @memberof CreateTableRequest
   */
  isActive?: boolean
}
/**
 *
 * @export
 * @interface CreateTableResponse
 */
export interface CreateTableResponse {
    /**
     * 
     * @type {string}
     * @memberof CreateTableResponse
     */
    tableId?: string;
}
/**
 * 
 * @export
 * @interface Dataset
 */
export interface Dataset {
  /**
   *
   * @type {string}
   * @memberof Dataset
   */
  datasetName?: string
  /**
   *
   * @type {Array<DatasetVersion>}
   * @memberof Dataset
   */
  allDatasetVersions?: Array<DatasetVersion>
  /**
   *
   * @type {DatasetDescription}
   * @memberof Dataset
   */
  activeVersionDescription?: DatasetDescription
}
/**
 * 
 * @export
 * @interface DatasetDescription
 */
export interface DatasetDescription {
  /**
   *
   * @type {string}
   * @memberof DatasetDescription
   */
  datasetId?: string
  /**
   *
   * @type {number}
   * @memberof DatasetDescription
   */
  datasetVersion?: number
  /**
   *
   * @type {string}
   * @memberof DatasetDescription
   */
  datasetVersionLabel?: string
  /**
   *
   * @type {string}
   * @memberof DatasetDescription
   */
  datasetDescription?: string
  /**
   *
   * @type {DatasetType}
   * @memberof DatasetDescription
   */
  datasetType?: DatasetType
  /**
   *
   * @type {string}
   * @memberof DatasetDescription
   */
  powerBiId?: string
  /**
   *
   * @type {string}
   * @memberof DatasetDescription
   */
  datasetMandatoryDataPoints?: string
  /**
   *
   * @type {number}
   * @memberof DatasetDescription
   */
  createdAt?: number
  /**
   *
   * @type {number}
   * @memberof DatasetDescription
   */
  updatedAt?: number
  /**
   *
   * @type {string}
   * @memberof DatasetDescription
   */
  createdBy?: string
  /**
   *
   * @type {string}
   * @memberof DatasetDescription
   */
  updatedBy?: string
}


/**
 * 
 * @export
 * @interface DatasetRule
 */
export interface DatasetRule {
    /**
     * 
     * @type {string}
     * @memberof DatasetRule
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof DatasetRule
     */
    rule?: string;
    /**
     * 
     * @type {DatasetRuleType}
     * @memberof DatasetRule
     */
    type?: DatasetRuleType;
}



/**
 * 
 * @export
 */
export const DatasetRuleType = {
    DaxQueryWritingRule: 'DAX_QUERY_WRITING_RULE',
    DataInqueryResponseWritingRule: 'DATA_INQUERY_RESPONSE_WRITING_RULE'
} as const;
export type DatasetRuleType = typeof DatasetRuleType[keyof typeof DatasetRuleType];


/**
 *
 * @export
 */
export const DatasetType = {
  PowerBi: 'POWER_BI',
  Sql: 'SQL',
} as const
export type DatasetType = typeof DatasetType[keyof typeof DatasetType];

/**
 * 
 * @export
 * @interface DatasetVersion
 */
export interface DatasetVersion {
  /**
   *
   * @type {string}
   * @memberof DatasetVersion
   */
  datasetId?: string
  /**
   *
   * @type {boolean}
   * @memberof DatasetVersion
   */
  isActiveVersion?: boolean
  /**
   *
   * @type {string}
   * @memberof DatasetVersion
   */
  datasetVersionLabel?: string
  /**
   *
   * @type {number}
   * @memberof DatasetVersion
   */
  datasetVersion?: number
  /**
   *
   * @type {DatasetType}
   * @memberof DatasetVersion
   */
  datasetType?: DatasetType
  /**
   *
   * @type {string}
   * @memberof DatasetVersion
   */
  datasetDescription?: string
  /**
   *
   * @type {string}
   * @memberof DatasetVersion
   */
  powerBiId?: string
  /**
   *
   * @type {string}
   * @memberof DatasetVersion
   */
  datasetMandatoryDataPoints?: string
  /**
   *
   * @type {number}
   * @memberof DatasetVersion
   */
  createdAt?: number
  /**
   *
   * @type {number}
   * @memberof DatasetVersion
   */
  updatedAt?: number
  /**
   *
   * @type {string}
   * @memberof DatasetVersion
   */
  createdBy?: string
  /**
   *
   * @type {string}
   * @memberof DatasetVersion
   */
  updatedBy?: string
}


/**
 * 
 * @export
 * @interface DaxUsagesResponse
 */
export interface DaxUsagesResponse {
    /**
     * 
     * @type {Usage}
     * @memberof DaxUsagesResponse
     */
    usages?: Usage;
    /**
     * 
     * @type {string}
     * @memberof DaxUsagesResponse
     */
    name?: string;
}
/**
 * 
 * @export
 * @interface GetColumnListResponse
 */
export interface GetColumnListResponse {
    /**
     * 
     * @type {Array<Column>}
     * @memberof GetColumnListResponse
     */
    columns?: Array<Column>;
}
/**
 * 
 * @export
 * @interface GetDatasetDetailsResponse
 */
export interface GetDatasetDetailsResponse {
  /**
   *
   * @type {string}
   * @memberof GetDatasetDetailsResponse
   */
  datasetId?: string
  /**
   *
   * @type {number}
   * @memberof GetDatasetDetailsResponse
   */
  datasetVersion?: number
  /**
   *
   * @type {string}
   * @memberof GetDatasetDetailsResponse
   */
  datasetName?: string
  /**
   *
   * @type {string}
   * @memberof GetDatasetDetailsResponse
   */
  datasetDescription?: string
  /**
   *
   * @type {DatasetType}
   * @memberof GetDatasetDetailsResponse
   */
  datasetType?: DatasetType
  /**
   *
   * @type {string}
   * @memberof GetDatasetDetailsResponse
   */
  powerBiId?: string
  /**
   *
   * @type {string}
   * @memberof GetDatasetDetailsResponse
   */
  datasetMandatoryDataPoints?: string
  /**
   *
   * @type {number}
   * @memberof GetDatasetDetailsResponse
   */
  createdAt?: number
  /**
   *
   * @type {number}
   * @memberof GetDatasetDetailsResponse
   */
  updatedAt?: number
  /**
   *
   * @type {string}
   * @memberof GetDatasetDetailsResponse
   */
  createdBy?: string
  /**
   *
   * @type {string}
   * @memberof GetDatasetDetailsResponse
   */
  updatedBy?: string
}


/**
 * @type GetDatasetVersions409Response
 * 
 * @export
 */
export type GetDatasetVersions409Response = ApiError | DaxUsagesResponse | SynonymsConflictApiError;
/**
 * 
 * @export
 * @interface GetDatasetVersionsResponse
 */
export interface GetDatasetVersionsResponse {
    /**
     * 
     * @type {Array<Dataset>}
     * @memberof GetDatasetVersionsResponse
     */
    datasets?: Array<Dataset>;
}
/**
 * 
 * @export
 * @interface GetMetricListResponse
 */
export interface GetMetricListResponse {
    /**
     * 
     * @type {Array<Metric>}
     * @memberof GetMetricListResponse
     */
    metrics?: Array<Metric>;
}
/**
 * 
 * @export
 * @interface GetTableListResponse
 */
export interface GetTableListResponse {
    /**
     * 
     * @type {Array<Table>}
     * @memberof GetTableListResponse
     */
    tables?: Array<Table>;
}
/**
 * 
 * @export
 * @interface Metric
 */
export interface Metric {
  /**
   *
   * @type {string}
   * @memberof Metric
   */
  metricId?: string
  /**
   *
   * @type {number}
   * @memberof Metric
   */
  metricVersion?: number
  /**
   *
   * @type {string}
   * @memberof Metric
   */
  metricName?: string
  /**
   *
   * @type {string}
   * @memberof Metric
   */
  metricDescription?: string
  /**
   *
   * @type {string}
   * @memberof Metric
   */
  metricFormula?: string
  /**
   *
   * @type {Array<DatasetRule>}
   * @memberof Metric
   */
  rules?: Array<DatasetRule>
  /**
   *
   * @type {Array<string>}
   * @memberof Metric
   */
  metricSynonyms?: Array<string>
  /**
   *
   * @type {MetricTypes}
   * @memberof Metric
   */
  metricType?: MetricTypes
  /**
   *
   * @type {number}
   * @memberof Metric
   */
  createdAt?: number
  /**
   *
   * @type {number}
   * @memberof Metric
   */
  updatedAt?: number
  /**
   *
   * @type {string}
   * @memberof Metric
   */
  createdBy?: string
  /**
   *
   * @type {string}
   * @memberof Metric
   */
  updatedBy?: string
  /**
   *
   * @type {boolean}
   * @memberof Metric
   */
  isActive?: boolean
}



/**
 *
 * @export
 */
export const MetricTypes = {
    Text: 'TEXT',
    Decimal: 'DECIMAL',
    Boolean: 'BOOLEAN',
    Enum: 'ENUM'
} as const;
export type MetricTypes = typeof MetricTypes[keyof typeof MetricTypes];

/**
 * 
 * @export
 * @interface SynonymsConflictApiError
 */
export interface SynonymsConflictApiError {
    /**
     * 
     * @type {string}
     * @memberof SynonymsConflictApiError
     */
    errorMessage?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof SynonymsConflictApiError
     */
    conflictingSynonyms?: Array<string>;
}
/**
 * 
 * @export
 * @interface Table
 */
export interface Table {
  /**
   *
   * @type {string}
   * @memberof Table
   */
  tableId?: string
  /**
   *
   * @type {string}
   * @memberof Table
   */
  tableName?: string
  /**
   *
   * @type {number}
   * @memberof Table
   */
  tableVersion?: number
  /**
   *
   * @type {string}
   * @memberof Table
   */
  tableDescription?: string
  /**
   *
   * @type {Array<string>}
   * @memberof Table
   */
  tableSynonyms?: Array<string>
  /**
   *
   * @type {Array<string>}
   * @memberof Table
   */
  joinedTableIds?: Array<string>
  /**
   *
   * @type {number}
   * @memberof Table
   */
  createdAt?: number
  /**
   *
   * @type {number}
   * @memberof Table
   */
  updatedAt?: number
  /**
   *
   * @type {string}
   * @memberof Table
   */
  createdBy?: string
  /**
   *
   * @type {string}
   * @memberof Table
   */
  updatedBy?: string
  /**
   *
   * @type {Array<Metric>}
   * @memberof Table
   */
  metrics?: Array<Metric>
  /**
   *
   * @type {Array<Column>}
   * @memberof Table
   */
  columns?: Array<Column>
  /**
   *
   * @type {boolean}
   * @memberof Table
   */
  isActive?: boolean
}
/**
 *
 * @export
 * @interface UpdateColumnRequest
 */
export interface UpdateColumnRequest {
  /**
   *
   * @type {number}
   * @memberof UpdateColumnRequest
   */
  columnVersion: number
  /**
   *
   * @type {string}
   * @memberof UpdateColumnRequest
   */
  columnName: string
  /**
   *
   * @type {string}
   * @memberof UpdateColumnRequest
   */
  columnDescription?: string
  /**
   *
   * @type {Array<DatasetRule>}
   * @memberof UpdateColumnRequest
   */
  rules?: Array<DatasetRule>
  /**
   *
   * @type {Array<string>}
   * @memberof UpdateColumnRequest
   */
  columnSynonyms?: Array<string>
  /**
   *
   * @type {MetricTypes}
   * @memberof UpdateColumnRequest
   */
  columnType?: MetricTypes
  /**
   *
   * @type {boolean}
   * @memberof UpdateColumnRequest
   */
  isActive?: boolean
}


/**
 *
 * @export
 * @interface UpdateColumnResponse
 */
export interface UpdateColumnResponse {
  /**
   *
   * @type {string}
   * @memberof UpdateColumnResponse
   */
  columnId?: string
  /**
   *
   * @type {number}
   * @memberof UpdateColumnResponse
   */
  columnNewVersion?: number
  /**
   *
   * @type {string}
   * @memberof UpdateColumnResponse
   */
  columnName?: string
  /**
   *
   * @type {string}
   * @memberof UpdateColumnResponse
   */
  columnDescription?: string
  /**
   *
   * @type {Array<DatasetRule>}
   * @memberof UpdateColumnResponse
   */
  rules?: Array<DatasetRule>
  /**
   *
   * @type {Array<string>}
   * @memberof UpdateColumnResponse
   */
  columnSynonyms?: Array<string>
  /**
   *
   * @type {MetricTypes}
   * @memberof UpdateColumnResponse
   */
  columnType?: MetricTypes
  /**
   *
   * @type {number}
   * @memberof UpdateColumnResponse
   */
  createdAt?: number
  /**
   *
   * @type {number}
   * @memberof UpdateColumnResponse
   */
  updatedAt?: number
  /**
   *
   * @type {string}
   * @memberof UpdateColumnResponse
   */
  createdBy?: string
  /**
   *
   * @type {string}
   * @memberof UpdateColumnResponse
   */
  updatedBy?: string
  /**
   *
   * @type {boolean}
   * @memberof UpdateColumnResponse
   */
  isActive?: boolean
}


/**
 * 
 * @export
 * @interface UpdateDatasetRequest
 */
export interface UpdateDatasetRequest {
  /**
   *
   * @type {number}
   * @memberof UpdateDatasetRequest
   */
  datasetVersion: number
  /**
   *
   * @type {string}
   * @memberof UpdateDatasetRequest
   */
  powerBiId?: string
  /**
   *
   * @type {string}
   * @memberof UpdateDatasetRequest
   */
  datasetDescription?: string
  /**
   *
   * @type {string}
   * @memberof UpdateDatasetRequest
   */
  datasetMandatoryDataPoints?: string
  /**
   *
   * @type {boolean}
   * @memberof UpdateDatasetRequest
   */
  datasetActivate?: boolean
}

/**
 *
 * @export
 * @interface UpdateDatasetResponse
 */
export interface UpdateDatasetResponse {
  /**
   *
   * @type {string}
   * @memberof UpdateDatasetResponse
   */
  datasetId?: string
  /**
   *
   * @type {number}
   * @memberof UpdateDatasetResponse
   */
  datasetVersion?: number
  /**
   *
   * @type {string}
   * @memberof UpdateDatasetResponse
   */
  datasetVersionLabel?: string
  /**
   *
   * @type {boolean}
   * @memberof UpdateDatasetResponse
   */
  isActiveVersion?: boolean
  /**
   *
   * @type {DatasetType}
   * @memberof UpdateDatasetResponse
   */
  datasetType?: DatasetType
  /**
   *
   * @type {string}
   * @memberof UpdateDatasetResponse
   */
  powerBiId?: string
  /**
   *
   * @type {string}
   * @memberof UpdateDatasetResponse
   */
  datasetDescription?: string
  /**
   *
   * @type {string}
   * @memberof UpdateDatasetResponse
   */
  datasetMandatoryDataPoints?: string
  /**
   *
   * @type {number}
   * @memberof UpdateDatasetResponse
   */
  createdAt?: number
  /**
   *
   * @type {number}
   * @memberof UpdateDatasetResponse
   */
  updatedAt?: number
  /**
   *
   * @type {string}
   * @memberof UpdateDatasetResponse
   */
  createdBy?: string
  /**
   *
   * @type {string}
   * @memberof UpdateDatasetResponse
   */
  updatedBy?: string
}


/**
 * 
 * @export
 * @interface UpdateMetricRequest
 */
export interface UpdateMetricRequest {
  /**
   *
   * @type {number}
   * @memberof UpdateMetricRequest
   */
  metricVersion: number
  /**
   *
   * @type {string}
   * @memberof UpdateMetricRequest
   */
  metricName: string
  /**
   *
   * @type {string}
   * @memberof UpdateMetricRequest
   */
  metricDescription?: string
  /**
   *
   * @type {Array<DatasetRule>}
   * @memberof UpdateMetricRequest
   */
  rules?: Array<DatasetRule>
  /**
   *
   * @type {string}
   * @memberof UpdateMetricRequest
   */
  metricFormula?: string
  /**
   *
   * @type {Array<string>}
   * @memberof UpdateMetricRequest
   */
  metricSynonyms?: Array<string>
  /**
   *
   * @type {MetricTypes}
   * @memberof UpdateMetricRequest
   */
  metricType?: MetricTypes
  /**
   *
   * @type {boolean}
   * @memberof UpdateMetricRequest
   */
  isActive?: boolean
}


/**
 *
 * @export
 * @interface UpdateMetricResponse
 */
export interface UpdateMetricResponse {
  /**
   *
   * @type {string}
   * @memberof UpdateMetricResponse
   */
  metricId?: string
  /**
   *
   * @type {number}
   * @memberof UpdateMetricResponse
   */
  metricNewVersion?: number
  /**
   *
   * @type {string}
   * @memberof UpdateMetricResponse
   */
  metricName?: string
  /**
   *
   * @type {string}
   * @memberof UpdateMetricResponse
   */
  metricDescription?: string
  /**
   *
   * @type {Array<DatasetRule>}
   * @memberof UpdateMetricResponse
   */
  rules?: Array<DatasetRule>
  /**
   *
   * @type {string}
   * @memberof UpdateMetricResponse
   */
  metricFormula?: string
  /**
   *
   * @type {Array<string>}
   * @memberof UpdateMetricResponse
   */
  metricSynonyms?: Array<string>
  /**
   *
   * @type {MetricTypes}
   * @memberof UpdateMetricResponse
   */
  metricType?: MetricTypes
  /**
   *
   * @type {number}
   * @memberof UpdateMetricResponse
   */
  createdAt?: number
  /**
   *
   * @type {number}
   * @memberof UpdateMetricResponse
   */
  updatedAt?: number
  /**
   *
   * @type {string}
   * @memberof UpdateMetricResponse
   */
  createdBy?: string
  /**
   *
   * @type {string}
   * @memberof UpdateMetricResponse
   */
  updatedBy?: string
  /**
   *
   * @type {boolean}
   * @memberof UpdateMetricResponse
   */
  isActive?: boolean
}


/**
 *
 * @export
 * @interface UpdateTableRequest
 */
export interface UpdateTableRequest {
  /**
   *
   * @type {number}
   * @memberof UpdateTableRequest
   */
  tableVersion: number
  /**
   *
   * @type {string}
   * @memberof UpdateTableRequest
   */
  tableName: string
  /**
   *
   * @type {string}
   * @memberof UpdateTableRequest
   */
  tableDescription?: string
  /**
   *
   * @type {Array<string>}
   * @memberof UpdateTableRequest
   */
  tableSynonyms?: Array<string>
  /**
   *
   * @type {Array<string>}
   * @memberof UpdateTableRequest
   */
  joinedTableIds?: Array<string>
  /**
   *
   * @type {boolean}
   * @memberof UpdateTableRequest
   */
  isActive?: boolean
}
/**
 *
 * @export
 * @interface UpdateTableResponse
 */
export interface UpdateTableResponse {
  /**
   *
   * @type {string}
   * @memberof UpdateTableResponse
   */
  tableId?: string
  /**
   *
   * @type {number}
   * @memberof UpdateTableResponse
   */
  tableNewVersion?: number
  /**
   *
   * @type {string}
   * @memberof UpdateTableResponse
   */
  tableName?: string
  /**
   *
   * @type {string}
   * @memberof UpdateTableResponse
   */
  tableDescription?: string
  /**
   *
   * @type {Array<string>}
   * @memberof UpdateTableResponse
   */
  tableSynonyms?: Array<string>
  /**
   *
   * @type {Array<string>}
   * @memberof UpdateTableResponse
   */
  joinedTableIds?: Array<string>
  /**
   *
   * @type {number}
   * @memberof UpdateTableResponse
   */
  createdAt?: number
  /**
   *
   * @type {number}
   * @memberof UpdateTableResponse
   */
  updatedAt?: number
  /**
   *
   * @type {string}
   * @memberof UpdateTableResponse
   */
  createdBy?: string
  /**
   *
   * @type {string}
   * @memberof UpdateTableResponse
   */
  updatedBy?: string
  /**
   *
   * @type {boolean}
   * @memberof UpdateTableResponse
   */
  isActive?: boolean
}
/**
 *
 * @export
 * @interface Usage
 */
export interface Usage {
    /**
     * 
     * @type {Array<Value>}
     * @memberof Usage
     */
    questions?: Array<Value>;
    /**
     * 
     * @type {Array<Value>}
     * @memberof Usage
     */
    tables?: Array<Value>;
    /**
     * 
     * @type {Array<Value>}
     * @memberof Usage
     */
    metrics?: Array<Value>;
}
/**
 * 
 * @export
 * @interface Value
 */
export interface Value {
    /**
     * 
     * @type {string}
     * @memberof Value
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof Value
     */
    value?: string;
}
